module.exports = __webpack_public_path__ + "img/logo.47220b28.png";